import axios from "../utils/axios.js";

export async function getEventById(eventId, includeTeams = false) {
    const response = await axios.get(`match/${eventId}`, {params: {include_teams: includeTeams}});
    return response.data;
}

export async function getEventWithLatestJobsById(eventId) {
    const response = await axios.get(`match/v2/eventWithLatestJobs/${eventId}`);
    return response.data;
}

export async function getTimelineEvent(id){
    const response = await axios.get(`match/v2/getTimelineEvent/${id}`)
    return response.data
}

export async function getEvents(filters) {
    const response = await axios.post(`/events`, {filters});
    return response.data;
}

export async function getEventAudioTracks(eventId){
    const response = await axios.get(`match/v2/audio_tracks/${eventId}`);
    return response.data
}

export async function updateEvent(eventId, body) {
    const response = await axios.put(`match/updateEvent/${eventId}`, body);
    return response.data;
}

export async function getEventStreamFrameRate(eventId) {
    const response = await axios.get(`match/v2/streamFrameRate/${eventId}`);
    return response.data[eventId] ? response.data[eventId] : 25;
}

export async function updateEventSchedule(eventId, startSchedule, endSchedule) {
    const response = await axios.put(`match/v2/schedule/${eventId}`, {startSchedule, endSchedule});
    return response.data;
}

export async function markPeriod(eventId, streamTime, gameTime, period) {
    const response = await axios.post(`match/v2/markPeriod/${eventId}`, {stream_time: streamTime, game_time: gameTime, period});
    return response.data;
}